<template>
  <div class="textcontent">    
    <div :key=line v-for="line in lines" class="content" v-html="line"></div>
  </div>
</template>

<script>
export default {
  name: "text-content",
  props: {lines: Array, delay: Number},
  mounted() {
    // console.log(`text content mounted delay ${this.delay}\n`)
    TweenMax.staggerFromTo('.content', .5, {  opacity: 0 }, { top: '-=50', ease: 'Expo.easeOut', opacity: 1, delay: this.delay }, .1);
  }, 
};
</script>

<style scoped>
  .content{
    position: relative;
  }
</style>





// WEBPACK FOOTER //
// TextContent.vue?1be2d307